export const withCategory = (rawEvents, eventCategory) => {
    return Object.fromEntries(
        Object.entries(rawEvents).map(([key, value]) => {
            if (typeof value === "string") {
                return [
                    key,
                    {
                        eventCategory,
                        event: value,
                        eventAction: value
                    }
                ];
            }

            return [
                key,
                {
                    eventCategory,
                    event: value.event,
                    eventAction: value.eventAction || value.event,
                    ...(value.eventLabel && { eventLabel: value.eventLabel })
                }
            ];
        })
    );
};

const EVENT_CATEGORIES = {
    PDI_BOOKING_FLOW_NEW: "pdi_book_flow_new",
    PDI_BOOKING_FLOW_USED: "pdi_book_flow_used",
    PDI_POST_ORDER_FLOW_NEW: "pdi_post_flow_new",
    PDI_POST_ORDER_FLOW_USED: "pdi_post_flow_used",
    PDI_POST_BOTTOM_SHEET_NEW: "pdi_post_bottomsheet_new",
    PDI_POST_BOTTOM_SHEET_USED: "pdi_post_bottomsheet_used",
    PDI_PROMISE_DETAIL_PAGE_POST: "pdi_promise_detail_page_post"
};

const rawPostOrderFlowEvents = {
    RESCHEDULE_CLICKED: "reschedule_clicked",
    CANCEL_CLICKED: "cancel_clicked",
    CALL_EXPERT_CLICKED: "Call_Expert_Clicked",
    DOWNLOAD_INVOICE: "download_invoice",
    DOWNLOAD_REPORT: "download_report",
    HELP_CLICKED: "help_clicked",
    APPOINTMENT_CONFIRMED_SESSION: "appointment_confirmed_session",
    EXPERT_ASSIGNED_SESSION: "expert_assigned_session",
    INSPECTION_DONE_SESSION: "insp_done_session",
    REPORT_READY_SESSION: "report_ready_session",
    PARTIAL_REPORT_READY_SESSION: "part_report_ready_session",
    SH_FAIL_SESSION: "no_service_record_session",
    INSPECTION_CANCELLED_SESSION: "insp_cancelled_session",
    REG_NUMBER_ENTERED: "reg_number_entered",
    REG_SUBMIT_CLICKED: "reg_submit_clicked"
};

const rawPostBottomsheetEvents = {
    CL_RESCHEDULE_PRIMARY_CLICKED: "CL_Reschedule_primary_clicked",
    CL_CANCEL_CLICKED: "CL_cancel_clicked",
    RS_RESCHEDULE_PRIMARY_CLICKED: "RS_Reschedule_primary_clicked",
    RS_GO_BACK_CLICKED: "RS_go_back_clicked"
};

const rawBookingFlowEvents = {
    APPOINTMENT_RESCHEDULED: "appointment_rescheduled",
    APPOINTMENT_CANCELLED: "appointment_cancelled",
    HELP_CLICKED: "help_clicked",
    PDI_PROMISE_POST_LOAD_PF: "pdi_promise_post_load_pf",
    PDI_PROMISE_POST_LOAD_NF: "pdi_promise_post_load_nf",
    PDI_PROMISE_POST_LOAD_F: "pdi_promise_post_load_f",
    PDI_PROMISE_POST_LOAD_PR: "pdi_promise_post_load_pr",
    PDI_PROMISE_POST_LOAD_FR: "pdi_promise_post_load_fr",
    PDI_PROMISE_POST_LOAD_EXP: "pdi_promise_post_load_exp",
    PDI_PROMISE_POST_CLICKED: "pdi_promise_post_clicked"
};

const rawPromiseDetailPageEvents = {
    PAGE_LOAD: "page_load",
    RAISE_ISSUE_CLICKED: "raise_issue_clicked"
};

const PDI_POST_ORDER_FLOW_NEW_EVENTS = withCategory(
    rawPostOrderFlowEvents,
    EVENT_CATEGORIES.PDI_POST_ORDER_FLOW_NEW
);
const PDI_POST_ORDER_FLOW_USED_EVENTS = withCategory(
    rawPostOrderFlowEvents,
    EVENT_CATEGORIES.PDI_POST_ORDER_FLOW_USED
);
const PDI_POST_BOTTOMSHEET_NEW_EVENTS = withCategory(
    rawPostBottomsheetEvents,
    EVENT_CATEGORIES.PDI_POST_BOTTOM_SHEET_NEW
);
const PDI_POST_BOTTOMSHEET_USED_EVENTS = withCategory(
    rawPostBottomsheetEvents,
    EVENT_CATEGORIES.PDI_POST_BOTTOM_SHEET_USED
);
const PDI_BOOKING_FLOW_NEW_EVENTS = withCategory(
    rawBookingFlowEvents,
    EVENT_CATEGORIES.PDI_BOOKING_FLOW_NEW
);
const PDI_BOOKING_FLOW_USED_EVENTS = withCategory(
    rawBookingFlowEvents,
    EVENT_CATEGORIES.PDI_BOOKING_FLOW_USED
);
const PDI_PROMISE_DETAIL_PAGE_POST_EVENTS = withCategory(
    rawPromiseDetailPageEvents,
    EVENT_CATEGORIES.PDI_PROMISE_DETAIL_PAGE_POST
);

export {
    PDI_POST_ORDER_FLOW_NEW_EVENTS,
    PDI_POST_ORDER_FLOW_USED_EVENTS,
    PDI_POST_BOTTOMSHEET_NEW_EVENTS,
    PDI_POST_BOTTOMSHEET_USED_EVENTS,
    PDI_BOOKING_FLOW_NEW_EVENTS,
    PDI_BOOKING_FLOW_USED_EVENTS,
    PDI_PROMISE_DETAIL_PAGE_POST_EVENTS
};
